import { z } from 'zod';

import { employeeCardSchema, permissionSchema } from './positions';

export const organizationCardSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  shortName: z.string(),
  description: z.string(),
  status: z.string(),
  isActive: z.boolean(),
  inn: z.string(),
  kpp: z.string(),
  ogrn: z.string(),
  legalForm: z.string(),
  email: z.string(),
  phone: z.string(),
  website: z.string(),
  userCount: z.number().int(),
});
export type OrganizationCard = z.infer<typeof organizationCardSchema>;

export const departmentSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  description: z.string(),
  headUserId: z.number().int().nullable(),
  email: z.string(),
  phone: z.string(),
  isActive: z.boolean(),
});
export type Department = z.infer<typeof departmentSchema>;

export const createDepartmentSchema = z.object({
  name: z.string().trim().min(1, 'Введите название').max(200),
  description: z.string().trim().max(1000).default(''),
});
export type CreateDepartment = z.infer<typeof createDepartmentSchema>;

export const memberSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  role: z.string(),
  /** Name of the catalog position, or a free-text position. */
  position: z.string(),
  positionId: z.number().int().nullable(),
  permissions: z.array(permissionSchema),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  driverLicenses: z.array(z.string()),
  departmentIds: z.array(z.number().int()),
  isActive: z.boolean(),
  joinedAt: z.string().nullable(),
});
export type Member = z.infer<typeof memberSchema>;

export const employeeSchema = z.object({
  subject: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  enabled: z.boolean(),
  /** Local user id; null until the account has a membership. */
  userId: z.number().int().nullable(),
  positionId: z.number().int().nullable(),
  position: z.string(),
  phone: z.string(),
  driverLicenses: z.array(z.string()),
});
export type Employee = z.infer<typeof employeeSchema>;

export const createEmployeeSchema = employeeCardSchema.extend({
  email: z.email('Введите email').trim().toLowerCase(),
  firstName: z.string().trim().min(1, 'Введите имя').max(100),
  lastName: z.string().trim().min(1, 'Введите фамилию').max(100),
  password: z.string().min(8, 'Временный пароль — не короче 8 символов').max(256),
});
export type CreateEmployee = z.infer<typeof createEmployeeSchema>;

export const updateEmployeeSchema = employeeCardSchema;
export type UpdateEmployee = z.infer<typeof updateEmployeeSchema>;

/** "Фамилия Имя", or the e-mail when the name is unknown. */
export function personName(person: { firstName: string; lastName: string; email?: string }) {
  return `${person.lastName} ${person.firstName}`.trim() || person.email || '';
}
